import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';

import { EventType } from '../models/events';

import { ConfigService } from '../services/config.service';
import { EventsManagerService } from '../services/eventsmanager.service';

import { map } from 'rxjs/operators';

import * as _ from 'lodash';

export const AUTH_CONST = {
  storageSession: 'ONAM_APP_SESSION',
  storageOptions: 'ONAM_APP_OPTIONS',
};

export const PERMISSIONS: any = {
  'ADMIN': [
    { name: 'DASHBOARD', view: true, edit: false, create: false, delete: false },
    { name: 'MODULE_ADMIN', view: true, edit: false, create: false, delete: false },
    { name: 'MENU_USERS', view: true, edit: true, create: true, delete: true },
    { name: 'MENU_MED_STUDIES', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_DOCTORS', view: true, edit: true, create: true, delete: true },
    { name: 'MENU_MED_SERVICES', view: true, edit: true, create: true, delete: true },
    { name: 'MODULE_ARCHIVE', view: true, edit: false, create: false, delete: false },
    { name: 'MENU_PATIENTS', view: true, edit: true, create: true, delete: true },
    { name: 'MODULE_CALENDAR', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_CALENDAR', view: false, edit: false, create: false, delete: false }
  ],
  'MANAGER': [
    { name: 'DASHBOARD', view: true, edit: false, create: false, delete: false },
    { name: 'MODULE_ADMIN', view: true, edit: false, create: false, delete: false },
    { name: 'MENU_USERS', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_MED_STUDIES', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_DOCTORS', view: true, edit: true, create: true, delete: true },
    { name: 'MENU_MED_SERVICES', view: true, edit: true, create: true, delete: true },
    { name: 'MODULE_ARCHIVE', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_PATIENTS', view: false, edit: false, create: false, delete: false },
    { name: 'MODULE_CALENDAR', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_CALENDAR', view: false, edit: false, create: false, delete: false }
  ],
  'DOCTOR': [
    { name: 'DASHBOARD', view: true, edit: false, create: false, delete: false },
    { name: 'MODULE_ADMIN', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_USERS', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_MED_STUDIES', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_DOCTORS', view: false, edit: false, create: false, delete: false },
    { name: 'MENU_MED_SERVICES', view: false, edit: false, create: false, delete: false },
    { name: 'MODULE_ARCHIVE', view: true, edit: false, create: false, delete: false },
    { name: 'MENU_PATIENTS', view: true, edit: true, create: true, delete: true },
    { name: 'MODULE_CALENDAR', view: true, edit: true, create: true, delete: true },
    { name: 'MENU_CALENDAR', view: true, edit: true, create: true, delete: true }
  ],
};

export const ONAM_SUBSCRIPTION: any = {
  'STUDIO': {
    period: 365,
    quantity: -1
  },
  'SINGLE_VISIT_BANGLE': {
    period: 0,
    quantity: 1
  },
  'SINGLE_VISIT_PRO': {
    period: 30,
    quantity: 1
  },
  'POSTURAL_CHECK_BASE': {
    period: 365,
    quantity: 1
  },
  'POSTURAL_CHECK_STANDARD': {
    period: 365,
    quantity: 2
  },
  'POSTURAL_CHECK_PLUS': {
    period: 365,
    quantity: 3
  }
};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentSession: any = null;
  private user: any = null;

  config: any = null;
  appConfig: any = null;

  apiUrl = '';

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private configService: ConfigService,
    private eventsManagerService: EventsManagerService
  ) {
    this.reloadSession();
  }

  setConfig(config: any) {
    this.config = config;
    if (this.config) {
      this.appConfig = this.config.AppConfig;

      this.apiUrl = this.appConfig.ONAMREST ? this.appConfig.ONAMREST.HOST : '';
    }
  }

  getApiUrl() {
    return this.apiUrl;
  }

  login(email: String, password: String) {
    const body = JSON.stringify({ email: email, password: password });

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Content-Type', 'application/json');

    let url = `${this.apiUrl}${this.appConfig.ONAMREST['LOGIN_MOBILE']}`;

    return this.http.post(url, body, {
        params: {},
        headers: headers
      })
      .pipe(map((response: any) => {
        if (response && response.access_token) {
          // store jwt token and user details (?) in local storage to keep user logged in between page refreshes
          this.setCurrentSession(response);

          this.reloadSession();

          let url = `${this.apiUrl}${this.appConfig.ONAMREST['PROFILE']}?include=roles,medicalservices,doctors`;
          this.http.get(url, {
            params: {},
            headers: headers
          }).subscribe(
            (response: any) => {
              const user = response.data;
              let options = user?.options ?? null;
              if (!options) {
                const defaultOptions = { language: 'it' };
                options = window.btoa(encodeURI(JSON.stringify(defaultOptions)));
              }
              localStorage.setItem(AUTH_CONST.storageOptions, options);
              const user_options = JSON.parse(decodeURI(atob(options)));
              this.translate.use(user_options.language);

              this.updateUserSession(user);
            }
          );
        } else {
          return { errors: { status: 401 } };
        }
        return response;
      }));
  }

  logout() {
    if (this.isLogged()) {
      // let url = `${this.appConfig.ONAMREST['HOST']}${this.appConfig.ONAMREST['LOGOUT']}`;
      // this.http.delete(url).subscribe(
      //   (response: any) => {
      //     // console.log('logout response', response);
      //   }
      // );
    }

    // remove user from local storage to log user out
    localStorage.removeItem(AUTH_CONST.storageSession);
    localStorage.removeItem(AUTH_CONST.storageOptions);
    console.log('logout');
  }

  getDecodeToken() {
    const token = this.getAuthorizationToken();
    return (JSON.parse(atob(token.split('.')[1])));
  }

  getTokenExpiredDate(ms = true): any {
    const tokenInfo = this.getDecodeToken();
    return ms ? (tokenInfo.exp * 1000) : (new Date(tokenInfo.exp * 1000));
  }

  tokenExpired() {
    const expiry = this.getTokenExpiredDate() / 1000;
    // console.log('tokenExpired expiry', expiry);
    // console.log('tokenExpired now', Math.floor((new Date).getTime() / 1000));
    // console.log('tokenExpired date', new Date(expiry * 1000));
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  reloadSession() {
    this.currentSession = this.getCurrentSession();
    this.user = this.getUser();
    this.eventsManagerService.broadcast(EventType.SESSION_UPDATE, this.currentSession);
  }

  updateUserSession(user: any) {
    this.currentSession = this.getCurrentSession();

    const data = {
      ...this.currentSession,
      user: user
    };
    this.setCurrentSession(data);

    this.reloadSession();
  }

  getUser() {
    return this.currentSession?.user ?? null;
  }

  getAuthorizationToken() {
    return this.currentSession?.access_token ?? 'no-auth-token';
  }

  isLogged() {
    if (this.currentSession && this.currentSession.access_token) {
      // console.log('isLogged true', this.currentSession.access_token);
      return true;
    }
    return false;
  }

  setCurrentSession(data: any) {
    const session = window.btoa(encodeURI(JSON.stringify(data)));
    localStorage.setItem(AUTH_CONST.storageSession, session);
  }

  getCurrentSession() {
    const storage = localStorage.getItem(AUTH_CONST.storageSession);
    if (storage) {
      const currentSession = JSON.parse(decodeURI(atob(storage)));
      return currentSession;
    }
    return null;
  }

  getRoles() {
    const user = this.getUser();
    return user?.roles?.data ?? [];
  }

  getRole(guard: String = 'web') {
    const roles = this.getRoles();
    const idx = roles.findIndex((x: any) => x.guard_name === guard);
    return (idx !== -1) ? roles[idx] : null;
  }

  getRolePermissions(role: String) {
    const roles = this.getRoles();
    const idx = roles.findIndex((x: any) => x.name === role);
    return (idx !== -1) ? roles[idx].permissions?.data : [];
  }

  hasRole(role: String) {
    const roles = this.getRoles();
    if (roles.findIndex((x: any) => x.name === role) > -1) {
      return true;
    }
    return false;
  }

  getPermissions() {
    const role = this.getRole();
    return role ? PERMISSIONS[role.name.toUpperCase()] : [];
  }

  hasPermission(value: String, grant: String = 'view', owner = true) {
    const uValue = value ? value.toUpperCase() : value;
    if (uValue === 'PUBLIC') { return true; }
    const permissions = this.getPermissions();
    const idx = permissions.findIndex((perm: any) => perm.name === uValue);
    const permission = (idx > -1) ? permissions[idx] : null;
    if (permission) {
      const grantStr = `${grant}`;
      return permission[grantStr];
    }
    return false;
  }


  isUser() {
    if (!this.user) {
      return false;
    } else {
      const roles = this.getRoles();
      return (this.isPatient() || (_.includes(roles, 'user')));
    }
  }

  isPatient() {
    if (!this.user) {
      return false;
    } else {
      const roles = this.getRoles();
      return (this.isAdmin() || (_.findIndex(roles, { name: 'patient' }) !== -1));
    }
  }

  isDoctor() {
    if (!this.user) {
      return false;
    } else {
      const roles = this.getRoles();
      return (this.isAdmin() || (_.findIndex(roles, { name: 'doctor' }) !== -1));
    }
  }

  isAdmin() {
    if (!this.user) {
      return false;
    } else {
      const roles = this.getRoles();
      return (this.isSuperAdmin() || (_.findIndex(roles, { name: 'manager' }) !== -1));
    }
  }

  isSuperAdmin() {
    if (!this.user) {
      return false;
    } else {
      const roles = this.getRoles();
      return (_.findIndex(roles, { name: 'admin' }) !== -1);
    }
  }

  private saveOptions(options: any) {
    // this.personaService.updateOptions(options)
    //     .subscribe(
    //         (response: any) => {
    //             // console.debug('updatePersonaOptions', response);
    //         }
    //     );
  }

  /*
    Ruoli:
    #1 - super_admin:
    #2 - admin:
    #3 - doctor:
    #4 - patient:
  */

  isMenuAuth(menu: any) {
    let auth = true;
    if (!this.isSuperAdmin() && menu.url !== '/dashboard') {
      const permessi: any = {};

      const ruolo: any = ''; // this.getRole();

      auth = ruolo && _.includes(permessi[ruolo.descrizione], menu.url);
    }

    return auth;
  }

  getSubscription(code: string) {
    return code ? ONAM_SUBSCRIPTION[code.toUpperCase()] : null;
  }
}
